export const OFFLINE = 'OFFLINE';
export const ONLINE = 'ONLINE';
export const SET_UNSUPPORTED_BROWSER_ALERT_OPEN = 'SET_UNSUPPORTED_BROWSER_ALERT_OPEN';
export const SET_UNSUPPORTED_BROWSER_ALERT_CLOSED = 'SET_UNSUPPORTED_BROWSER_ALERT_CLOSED';
export const SET_OFFLINE_ALERT_OPEN = 'SET_OFFLINE_ALERT_OPEN';
export const SET_OFFLINE_ALERT_CLOSED = 'SET_OFFLINE_ALERT_CLOSED';

export const openUnsupportedBrowserAlert = () => ({
  type: SET_UNSUPPORTED_BROWSER_ALERT_OPEN,
});

export const closeUnsupportedBrowserAlert = () => ({
  type: SET_UNSUPPORTED_BROWSER_ALERT_CLOSED,
});

export const openOfflineAlert = () => ({
  type: SET_OFFLINE_ALERT_OPEN,
});

export const closeOfflineAlert = () => ({
  type: SET_OFFLINE_ALERT_CLOSED,
});

export const handleOffline = () => ({
  type: OFFLINE,
});

export const handleOnline = () => ({
  type: ONLINE,
});
